import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Animated, View, ScrollView } from 'react-native';
import { DenseButtonView } from '../Buttons/DenseButtonView';
import { BoldView } from '../Typography/BoldView';
import { AnimatedTextView } from '../Typography/AnimatedTextView';
import { useDimensionAnimation } from '../Animations/AnimationHooks';
import { FadeView } from '../Animations/FadeView';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { Shadow } from '../../Styles/Shadow';
export const CollapseCardView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.collapseCard,
    style(theme, mediaQuery, window, props) {
        return {
            container: Object.assign({ position: 'relative', flex: 1, backgroundColor: '#ffffff', borderRadius: 8 }, Shadow.level(typeof props.shadowLevel === 'number'
                ? props.shadowLevel
                : 1)),
            body: {
                zIndex: -1
            },
            content: {
                paddingHorizontal: 20
            },
            header: {
                flexDirection: 'row',
                alignItems: 'center',
                borderRadius: 8,
                backgroundColor: '#ffffff',
                paddingHorizontal: 20,
                paddingVertical: 17
            },
            headerExpanded: {
                borderBottomColor: '#DBE2EB',
                borderBottomWidth: 1,
                borderBottomEndRadius: 0,
                borderBottomStartRadius: 0
            },
            title: {
                flex: 1,
                fontSize: 14,
                lineHeight: 18,
                fontWeight: 'bold',
                textTransform: 'uppercase'
            },
            btn: {},
            viewBtn: {
                borderBottomWidth: 2,
                borderBottomColor: '#63788F'
            }
        };
    }
})(({ style, defaultState, maxHeight, title, children, containerStyles, titleStyles, bodyStyles }) => {
    const [isExpanded, setIsExpanded] = useState(!!defaultState);
    const [height, setHeight] = useDimensionAnimation({ initialValue: 0 });
    const [paddingVertical, setPaddingVertical] = useState(0);
    useEffect(() => {
        const value = isExpanded
            ? maxHeight
            : 55;
        setHeight(value);
        let timeout = null;
        if (isExpanded) {
            setPaddingVertical(20);
        }
        else {
            timeout = setTimeout(() => {
                setPaddingVertical(0);
            }, 300);
        }
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [isExpanded]);
    const allBodyStyles = [style === null || style === void 0 ? void 0 : style.body, bodyStyles];
    return (_jsx(View, { style: [style === null || style === void 0 ? void 0 : style.container, containerStyles], children: _jsx(Animated.View, { style: [{ maxHeight: height }], children: _jsxs(ScrollView, { stickyHeaderIndices: [0], persistentScrollbar: true, children: [_jsx(View, { children: _jsxs(View, { style: [style === null || style === void 0 ? void 0 : style.header, isExpanded && (style === null || style === void 0 ? void 0 : style.headerExpanded), titleStyles], children: [_jsx(AnimatedTextView, { textStyle: style === null || style === void 0 ? void 0 : style.title, children: title }), _jsx(DenseButtonView, { wrapperStyle: [{ flex: undefined }, !isExpanded && (style === null || style === void 0 ? void 0 : style.viewBtn)], onPress: () => setIsExpanded(!isExpanded), children: _jsx(BoldView, { textStyle: style === null || style === void 0 ? void 0 : style.btn, children: isExpanded
                                            ? 'Hide'
                                            : 'View' }) })] }) }), _jsx(View, { style: allBodyStyles, children: _jsx(FadeView, { visible: isExpanded, style: [style === null || style === void 0 ? void 0 : style.content, { paddingVertical }], children: children }) })] }) }) }));
});
